import React from 'react';

const Flex =(props)=><div style={{display: "flex"}}>{props.children}</div>
export { Flex };


// WEBPACK FOOTER //
// ./src/components/common/Flex.js